<!-- Modal Header -->
@if (modal_name) {
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise = !minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>
}

<!-- Modal Body -->
<div class="modal-body" [ngClass]="{'no-body-scroll': modal_name}" [hidden]="minimise">

  <!-- Loading Spinner -->
  @if (showFormLoader) {
<div class="loading-container">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <!-- Beginning/Ending Period -->
    <div class="row form-group">
      <div class="col-md-6">
        <div class="row">
          <label class="col-md-6">Beginning period (MM/DD/YYYY):</label>
          <div class="col-md-4">
            <input type="date" class="form-control"
                   [ngModel]="formatDateForInput(attribData['5471_NA_CFC_BEGIN_DATE'])"
                   (ngModelChange)="onDateChange($event, '5471_NA_CFC_BEGIN_DATE')">
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <label class="col-md-6">Ending period (MM/DD/YYYY):</label>
          <div class="col-md-4">
            <input type="date" class="form-control"
                   [ngModel]="formatDateForInput(attribData['5471_NA_CFC_END_DATE'])"
                   (ngModelChange)="onDateChange($event, '5471_NA_CFC_END_DATE')">
          </div>
        </div>
      </div>
    </div>

    <!-- Filing Group -->
    <div class="row form-group">
      <label class="col-md-6">Filing Group</label>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="selectedGroup" (ngModelChange)="onFilingGroupChange($event)">
          <option [ngValue]="null">Select Filing Group</option>
          @for (fg of filingGroup; track $index) {
<option [ngValue]="fg">{{ fg.LEGAL_ENTITY_NAME }}</option>
}
        </select>
      </div>
    </div>

    <!-- Name of person filing / Identifying Number -->
    <div class="row form-group">
      <div class="col-md-6">
        <label>Name of person filing this return:</label>
        <div>{{ selectedGroup?.LEGAL_ENTITY_NAME }}</div>
      </div>
      <div class="col-md-6">
        <label class="pull-left">A.</label>
        <div class="pull-left">Identifying Number
          <br />{{ selectedGroup?.FILER_EIN || "" }}</div>
      </div>
    </div>

    <!-- Address Line 1 / Category of filer (B) -->
    <div class="row form-group">
      <div class="col-md-6">
        <label>Number, Street and Room or Suite No.</label>
        <div>{{ selectedGroup?.FILER_ADDR_LINE1 }}</div>
      </div>
      @if (tax_year_flag) {
<div class="col-md-6">
        <label class="pull-left">B.</label>
        <div class="pull-left">
          <span>Category of filter (Check applicable box(es)):</span>
          <div class="row">
            <span class="col-md-3">
              1
              <input type="checkbox" [(ngModel)]="checkBoxb1" (change)="set_override_flag(checkBoxb1 ? '1' : '0', '5471_NA_B_1_Y')">
              <i class="fa fa-question-circle"></i>
            </span>
            <span class="col-md-3">
              3
              <input type="checkbox" [(ngModel)]="checkBoxb3" (change)="set_override_flag(checkBoxb3 ? '1' : '0', '5471_NA_B_3_Y')">
              <i class="fa fa-question-circle"></i>
            </span>
            <span class="col-md-3">
              4
              <input type="checkbox" [(ngModel)]="checkBoxb4" (change)="set_override_flag(checkBoxb4 ? '1' : '0', '5471_NA_B_4_Y')">
              <i class="fa fa-question-circle"></i>
            </span>
            <span class="col-md-3">
              5
              <input type="checkbox" [(ngModel)]="checkBoxb5" (change)="set_override_flag(checkBoxb5 ? '1' : '0', '5471_NA_B_5_Y')">
              <i class="fa fa-question-circle"></i>
            </span>
          </div>
        </div>
      </div>
}
      @if (!tax_year_flag) {
<div class="col-md-6">
        <label class="pull-left">B.</label>
        <div class="pull-left">
          <span>Category of filter (Check applicable box(es)):</span>
          <div class="row">
            <span class="col-md-1">
              1a
              <input type="checkbox" [(ngModel)]="checkBoxb1a" (change)="set_override_flag(checkBoxb1a ? '1' : '0', '5471_NA_B_1A_Y')">
            </span>
            <span class="col-md-1">
              1b
              <input type="checkbox" [(ngModel)]="checkBoxb1b" (change)="set_override_flag(checkBoxb1b ? '1' : '0', '5471_NA_B_1B_Y')">
            </span>
            <span class="col-md-1">
              1c
              <input type="checkbox" [(ngModel)]="checkBoxb1c" (change)="set_override_flag(checkBoxb1c ? '1' : '0', '5471_NA_B_1C_Y')">
            </span>
            <span class="col-md-1">
              2
              <input type="checkbox" [(ngModel)]="checkBoxb2" (change)="set_override_flag(checkBoxb2 ? '1' : '0', '5471_NA_B_2_Y')">
            </span>
            <span class="col-md-1">
              3
              <input type="checkbox" [(ngModel)]="checkBoxb3" (change)="set_override_flag(checkBoxb3 ? '1' : '0', '5471_NA_B_3_Y')">
            </span>
            <span class="col-md-1">
              4
              <input type="checkbox" [(ngModel)]="checkBoxb4" (change)="set_override_flag(checkBoxb4 ? '1' : '0', '5471_NA_B_4_Y')">
            </span>
            <span class="col-md-1">
              5a
              <input type="checkbox" [(ngModel)]="checkBoxb5a" (change)="set_override_flag(checkBoxb5a ? '1' : '0', '5471_NA_B_5A_Y')">
            </span>
            <span class="col-md-1">
              5b
              <input type="checkbox" [(ngModel)]="checkBoxb5b" (change)="set_override_flag(checkBoxb5b ? '1' : '0', '5471_NA_B_5B_Y')">
            </span>
            <span class="col-md-1">
              5c
              <input type="checkbox" [(ngModel)]="checkBoxb5c" (change)="set_override_flag(checkBoxb5c ? '1' : '0', '5471_NA_B_5C_Y')">
            </span>
          </div>
        </div>
      </div>
}
    </div>

    <!-- City/State/Zip / Section C (voting stock %) -->
    <div class="row form-group">
      <div class="col-md-6">
        <label>City or Town, State and Zip code</label>
        <div>{{ selectedGroup?.FILER_ADDR_LINE2 }}</div>
      </div>
      <div class="col-md-6">
        <div>
          <b>C.</b>Enter the percentage of voting stock of foreign corporation you owned at the end of its annual accounting period
        </div>
        <div class="col-md-6">
          <div class="input-group">
            <input type="text" name="percent" [(ngModel)]="attribData['5471_NA_C']" class="form-control" id="percent"
                   maxlength="9" style="text-align: right;"
                   (ngModelChange)="changedPercent(attribData['5471_NA_C'])">
            <span class="input-group-addon">%</span>
          </div>
          @if (!checkFlag) {
<span class="form-error-container">Invalid entry, Percentage interest has to be between 0 and 100%</span>
}
        </div>
      </div>
    </div>

    <!-- Filer's tax year -->
    <div class="row form-group">
      <div class="col-md-12">
        <b>Filer's tax year</b>
      </div>
      <div class="col-md-6">
        <label>Beginning period (MM/DD/YYYY):</label>
        <div>{{ formatDate(selectedGroup?.FILER_TAX_YEAR_BEGIN) }}</div>
      </div>
      <div class="col-md-6">
        <label>Ending period (MM/DD/YYYY):</label>
        <div>{{ formatDate(selectedGroup?.FILER_TAX_YEAR_END) }}</div>
      </div>
    </div>

    <!-- Checkbox D -->
    <div class="row form-group">
      <label class="col-md-6"><strong>D.</strong> Check box if this is a final Form 5471 for the foreign corporation</label>
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="checkBoxd" (change)="set_flag(checkBoxd ? '1' : '0', 'd')">
      </div>
    </div>

    <!-- Checkbox F (if !tax_year_flag) -->
    @if (!tax_year_flag) {
<div class="row form-group">
      <label class="col-md-6">F. Check the box if this Form 5471 has been completed using Alternative Information under Rev. Proc. 2019-40</label>
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="checkBoxf" (change)="checkingForValidationForI(checkBoxf ? '1' : '0')">
      </div>
    </div>
}

    <!-- Section G (if !tax_year_flag) -->
    @if (!tax_year_flag) {
<div class="row form-group">
      <div class="col-md-6">
        <b>G. </b><label>If the box on line F is checked, enter the corresponding code for Alternative Information (see instructions)</label>
      </div>
      <div class="col-md-6">
        <input type="text" [(ngModel)]="attribData['5471_NA_ALT_INFO_2019_40_CODE']" class="form-control"
               [disabled]="checkBoxf !== true" (ngModelChange)="set_flag(attribData['5471_NA_ALT_INFO_2019_40_CODE'], 'g')">
      </div>
    </div>
}

    <!-- Person(s) on whose behalf -->
    <div class="row form-group">
      <label class="col-md-6">Person(s) on whose behalf this information return is filed</label>
      <div class="col-md-6">
        @if (!loadingfob) {
<div class="loading-container">
          <i class="fa fa-spinner fa-spin"></i>
        </div>
}
        @if (loadingfob) {
<select class="form-control" [(ngModel)]="filedOnBehalf" (ngModelChange)="onPersonBehalfChange($event)">
          <option [ngValue]="null">Select</option>
          @for (fob of fobDetails; track $index) {
<option [ngValue]="fob">{{ fob.ENTITY_DD }}</option>
}
        </select>
}
      </div>
    </div>

    <!-- Shareholder/Officer/Director checkboxes -->
    <div class="col-md-12">
      <div class="pull-left">
        <span>Check applicable box(es):</span>
        <div class="row">
          <span class="col-md-4">
            Shareholder
            <input type="checkbox" [(ngModel)]="checkShareholder" (change)="set_override_flag(checkShareholder ? '1' : '0', '5471_NA_FOB_SHAREHOLDER_Y')">
          </span>
          <span class="col-md-3">
            Officer
            <input type="checkbox" [(ngModel)]="checkOfficer" (change)="set_override_flag(checkOfficer ? '1' : '0', '5471_NA_FOB_OFFICER_Y')">
          </span>
          <span class="col-md-3">
            Director
            <input type="checkbox" [(ngModel)]="checkDirector" (change)="set_override_flag(checkDirector ? '1' : '0', '5471_NA_FOB_DIRECTOR_Y')">
          </span>
        </div>
      </div>
    </div>

    <!-- Section 1a - Name of foreign corporation -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>1.&emsp;a.&emsp;</b>Name of foreign corporation
      </div>
      <div class="col-md-6">
        <input class="form-control" type="text" [(ngModel)]="attribData['5471_NA_CFC_NAME_LINE1']" disabled>
      </div>
    </div>

    <!-- Address of foreign corporation -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;&emsp;&emsp;</b>Address of foreign corporation
      </div>
    </div>

    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Country</div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="countryVar" disabled>
          <option value="">Select Country</option>
          @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE">
            {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
          </option>
}
        </select>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Line 1:</div>
      <div class="col-md-6">
        @if (countryVar !== 'US') {
<input type="text" class="form-control" [(ngModel)]="attribData['5471_NA_CFC_F_ADDRESS_1']" disabled>
}
        @if (countryVar === 'US') {
<input type="text" class="form-control" [(ngModel)]="attribData['5471_NA_CFC_US_ADDRESS_1']" disabled>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Line 2:</div>
      <div class="col-md-6">
        @if (countryVar !== 'US') {
<input type="text" class="form-control" [(ngModel)]="attribData['5471_NA_CFC_F_ADDRESS_2']" disabled>
}
        @if (countryVar === 'US') {
<input type="text" class="form-control" [(ngModel)]="attribData['5471_NA_CFC_US_ADDRESS_2']" disabled>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>City:</div>
      <div class="col-md-6">
        @if (countryVar !== 'US') {
<input type="text" class="form-control" [(ngModel)]="attribData['5471_NA_CFC_F_CITY']" disabled>
}
        @if (countryVar === 'US') {
<input type="text" class="form-control" [(ngModel)]="attribData['5471_NA_CFC_US_CITY']" disabled>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>State:</div>
      <div class="col-md-6">
        @if (countryVar === 'US') {
<select class="form-control" [(ngModel)]="attribData['5471_NA_CFC_US_STATE']" disabled>
          <option value="">Select State</option>
          @for (state of states; track $index) {
<option [value]="state.CODE">{{ state.CODE }} - {{ state.NAME }}</option>
}
        </select>
}
        @if (countryVar !== 'US') {
<input type="text" class="form-control" [(ngModel)]="attribData['5471_NA_CFC_F_STATE']" disabled>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Zip/Postal Code:</div>
      <div class="col-md-6">
        @if (countryVar !== 'US') {
<input type="text" class="form-control" [(ngModel)]="attribData['5471_NA_CFC_F_ZIPCODE']" disabled>
}
        @if (countryVar === 'US') {
<input type="text" class="form-control" [(ngModel)]="attribData['5471_NA_CFC_US_ZIPCODE']" disabled>
}
      </div>
    </div>

    <!-- 1b(1) Identifying number -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;b(1).&emsp;</b>Identifying number (if any)
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <input class="form-control" type="text" maxlength="10" [(ngModel)]="attribData['5471_NA_1B(1)_EIN_NUMBER']"
                   (ngModelChange)="uncheckedRadio(attribData['5471_NA_1B(1)_EIN_NUMBER'], attribData['5471_NA_1B(1)_EIN_MISSING_REASON'], attribData['5471_NA_1B(2)'])">
          </div>
          <div class="col-md-4">
            <input type="radio" name="identify" value="APPLD FOR" [(ngModel)]="attribData['5471_NA_1B(1)_EIN_MISSING_REASON']"
                   (ngModelChange)="radioClicked(attribData['5471_NA_1B(1)_EIN_MISSING_REASON'], attribData['5471_NA_1B(1)_EIN_NUMBER'], attribData['5471_NA_1B(2)'])"/> Applied For
          </div>
          <div class="col-md-4">
            <input type="radio" name="identify" value="FOREIGNUS" [(ngModel)]="attribData['5471_NA_1B(1)_EIN_MISSING_REASON']"
                   (ngModelChange)="radioClicked(attribData['5471_NA_1B(1)_EIN_MISSING_REASON'], attribData['5471_NA_1B(1)_EIN_NUMBER'], attribData['5471_NA_1B(2)'])"/> Not Applicable
          </div>
        </div>
      </div>
    </div>

    <!-- 1b(2) Reference ID -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;b(2).&emsp;</b>Reference ID number (see instructions)
      </div>
      <div class="col-md-4">
        <input class="form-control" type="text" [(ngModel)]="attribData['5471_NA_1B(2)']"
               [disabled]="refrence_iddisabled === false"
               (ngModelChange)="ref_id(attribData['5471_NA_1B(2)'], attribData['5471_NA_1B(1)_EIN_MISSING_REASON'], attribData['5471_NA_1B(1)_EIN_NUMBER'])">
      </div>
    </div>

    <!-- 1b(3) Previous Reference ID (if tax_year > 2022) -->
    @if ((getCorrectTaxYear() || '0') > '2022') {
<div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;b(3).&emsp;</b>Previous Reference ID number(s), if any (see instructions)
      </div>
      <div class="col-md-4">
        <input class="form-control" type="text" [(ngModel)]="attribData['5471_NA_1B(3)']" (ngModelChange)="prev_ref_id(attribData['5471_NA_1B(3)'])">
      </div>
    </div>
}

    <!-- 1c Country under whose laws incorporated -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;c.&emsp;</b>Country under whose laws incorporated
      </div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="attribData['5471_NA_1C']" (ngModelChange)="changeCountryLaws(attribData['5471_NA_1C'])">
          <option value="">Select Country</option>
          @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE">
            {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- 1d Date of incorporation -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;d.&emsp;</b>Date of incorporation (MM/DD/YYYY)
      </div>
      <div class="col-md-6">
        <input type="date" class="form-control"
               [ngModel]="formatDateForInput(attribData['5471_NA_1D'])"
               (ngModelChange)="onDateChange($event, '5471_NA_1D')">
      </div>
    </div>

    <!-- 1e Principal place of business -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;e.&emsp;</b>Principal place of business
      </div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="attribData['5471_NA_1E']" (ngModelChange)="changePrincipalPlace(attribData['5471_NA_1E'])">
          <option value="">Select Country</option>
          @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE">
            {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- 1f Principal business activity code -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;f.&emsp;</b>Principal business activity code number
      </div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="selectedGroup1" (ngModelChange)="onPBAChange($event)">
          <option [ngValue]="null">Select Principal Business Activity</option>
          @for (pba of PrincipalBusinessActivity; track $index) {
<option [ngValue]="pba">
            {{ pba.ACTIVITY_CODE }} - {{ pba.ACTIVITY_DESC }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- 1g Principal business activity -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;g.&emsp;</b>Principal business activity
      </div>
      <div class="col-md-6">
        <div>{{ selectedGroup1?.ACTIVITY_DESC }}</div>
      </div>
    </div>

    <!-- 1h Functional currency -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;h.&emsp;</b>Functional currency
      </div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="attribData['5471_NA_1H']" disabled>
          <option value="">Select Functional Currency</option>
          @for (curr of currencies; track $index) {
<option [value]="curr.CURR_CODE">
            {{ curr.CURR_CODE }} - {{ curr.CURR_DESC }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- Section 2 intro -->
    <div class="row form-group">
      <div class="col-md-12">
        <b>2.&emsp;&emsp;&emsp;Provide the following information for the foreign corporation's accounting period stated above.</b>
      </div>
    </div>

    <!-- Section 2a - Branch office or agent in US -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;a.&emsp;</b>Name, address, and identifying number of branch office or agent (if any) in the United States
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Name:</div>
      <div class="col-md-6">
        <input class="form-control" type="text" maxlength="75" [(ngModel)]="attribData['5471_NA_BRANCH_US_NAME_1']"
               (ngModelChange)="change2a('5471_NA_BRANCH_US_NAME_1', attribData['5471_NA_BRANCH_US_NAME_1'])"
               [disabled]="batch_flag_2a">
        @if (line_2a_name) {
<span class="form-error-container">Name of branch office or agent (if any) in the United States is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Country:</div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="countryAgent" (ngModelChange)="changeCountryAgent(countryAgent)"
               [disabled]="batch_flag_2a">
          <option value="">Select Country</option>
          @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE">
            {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
          </option>
}
        </select>
        @if (line_2a_country_flag) {
<span class="form-error-container">Country is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Address Line 1:</div>
      <div class="col-md-6">
        @if (countryAgent !== 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_BRANCH_US_F_ADDR_1']"
               (ngModelChange)="change2a('5471_NA_BRANCH_US_F_ADDR_1', attribData['5471_NA_BRANCH_US_F_ADDR_1'])" [disabled]="batch_flag_2a">
}
        @if (countryAgent === 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_BRANCH_US_ADDR_LINE_1']"
               (ngModelChange)="change2a('5471_NA_BRANCH_US_ADDR_LINE_1', attribData['5471_NA_BRANCH_US_ADDR_LINE_1'])" [disabled]="batch_flag_2a">
}
        @if (add_flag_2a || add_flag_2a_f) {
<span class="form-error-container">Adrress Line 1 is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Address Line 2:</div>
      <div class="col-md-6">
        @if (countryAgent !== 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_BRANCH_US_F_ADDR_2']" [disabled]="batch_flag_2a">
}
        @if (countryAgent === 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_BRANCH_US_ADDR_LINE_2']" [disabled]="batch_flag_2a">
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>City:</div>
      <div class="col-md-6">
        @if (countryAgent !== 'US') {
<input class="form-control" type="text" maxlength="50" [(ngModel)]="attribData['5471_NA_BRANCH_US_F_CITY']"
               (ngModelChange)="change2a('5471_NA_BRANCH_US_F_CITY', attribData['5471_NA_BRANCH_US_F_CITY'])" [disabled]="batch_flag_2a">
}
        @if (countryAgent === 'US') {
<input class="form-control" type="text" maxlength="50" [(ngModel)]="attribData['5471_NA_BRANCH_US_CITY']"
               (ngModelChange)="change2a('5471_NA_BRANCH_US_CITY', attribData['5471_NA_BRANCH_US_CITY'])" [disabled]="batch_flag_2a">
}
        @if (city_flag_2a) {
<span class="form-error-container">City is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>State:</div>
      <div class="col-md-6">
        @if (countryAgent === 'US') {
<select class="form-control" [(ngModel)]="attribData['5471_NA_BRANCH_US_STATE']"
                (ngModelChange)="change2a('5471_NA_BRANCH_US_STATE', attribData['5471_NA_BRANCH_US_STATE'])" [disabled]="batch_flag_2a">
          <option value="">Select State</option>
          @for (state of states; track $index) {
<option [value]="state.CODE">{{ state.CODE }} - {{ state.NAME }}</option>
}
        </select>
}
        @if (countryAgent !== 'US') {
<input type="text" maxlength="17" class="form-control" [(ngModel)]="attribData['5471_NA_BRANCH_US_F_STATE']"
               (ngModelChange)="change2a('5471_NA_BRANCH_US_F_STATE', attribData['5471_NA_BRANCH_US_F_STATE'])" [disabled]="batch_flag_2a">
}
        @if (state_flag_2a) {
<span class="form-error-container">State is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Zip/Postal Code:</div>
      <div class="col-md-6">
        @if (countryAgent !== 'US') {
<input class="form-control" type="text" maxlength="16" [(ngModel)]="attribData['5471_NA_BRANCH_F_ZIP']"
               (ngModelChange)="change2a('5471_NA_BRANCH_F_ZIP', attribData['5471_NA_BRANCH_F_ZIP'])" [disabled]="batch_flag_2a">
}
        @if (countryAgent === 'US') {
<input class="form-control" type="text" maxlength="5" [(ngModel)]="attribData['5471_NA_BRANCH_US_ZIP']"
               (ngModelChange)="change2a('5471_NA_BRANCH_US_ZIP', attribData['5471_NA_BRANCH_US_ZIP'])" [disabled]="batch_flag_2a">
}
        @if (zip_flag_2a) {
<span class="form-error-container">Zip is required</span>
}
        @if (zip_flag_2a_pattern) {
<span class="form-error-container">Please enter valid Zip Code</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Identifying number (if any)</div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <input class="form-control" type="text" maxlength="10" [(ngModel)]="attribData['5471_NA_2A_EIN_NUMBER']"
                   (ngModelChange)="unchecked2a()" [disabled]="batch_flag_2a">
          </div>
          <div class="col-md-4">
            <input type="radio" name="identifyInfoAgent" value="APPLD FOR" [(ngModel)]="attribData['5471_NA_2A_EIN_MISSING_REASON']" (click)="clicked2a()" [disabled]="batch_flag_2a"/> Applied For
          </div>
          <div class="col-md-4">
            <input type="radio" name="identifyInfoAgent" value="FOREIGNUS" [(ngModel)]="attribData['5471_NA_2A_EIN_MISSING_REASON']" (click)="clicked2a()" [disabled]="batch_flag_2a"/> Not Applicable
          </div>
        </div>
      </div>
    </div>

    <!-- Section 2c - Foreign agent -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;2 c.&emsp;</b>Name and address of foreign corporation's statutory or resident agent in country of incorporation
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Name:</div>
      <div class="col-md-6">
        <input class="form-control" type="text" maxlength="75" [(ngModel)]="attribData['5471_NA_FOREIGN_AGENT_NAME_1']"
               (ngModelChange)="change2c('5471_NA_FOREIGN_AGENT_NAME_1', attribData['5471_NA_FOREIGN_AGENT_NAME_1'])"
               [disabled]="batch_flag_2c">
        @if (line_2c_name) {
<span class="form-error-container">Name for the foreign corporation statutory or resident agent in country of incorporation is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Country:</div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="countryCorporation" (ngModelChange)="changeCountryCorporation(countryCorporation)"
               [disabled]="batch_flag_2c">
          <option value="">Select Country</option>
          @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE">
            {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
          </option>
}
        </select>
        @if (line_2c_country_flag) {
<span class="form-error-container">Country is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Address Line 1:</div>
      <div class="col-md-6">
        @if (countryCorporation !== 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_FOREIGN_AGENT_F_ADDR_1']"
               (ngModelChange)="change2c('5471_NA_FOREIGN_AGENT_F_ADDR_1', attribData['5471_NA_FOREIGN_AGENT_F_ADDR_1'])" [disabled]="batch_flag_2c">
}
        @if (countryCorporation === 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_FOREIGN_AGENT_ADDR_1']"
               (ngModelChange)="change2c('5471_NA_FOREIGN_AGENT_ADDR_1', attribData['5471_NA_FOREIGN_AGENT_ADDR_1'])" [disabled]="batch_flag_2c">
}
        @if (add_flag_2c || add_flag_2c_f) {
<span class="form-error-container">Adrress Line 1 is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Address Line 2:</div>
      <div class="col-md-6">
        @if (countryCorporation !== 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_FOREIGN_AGENT_F_ADDR_2']" [disabled]="batch_flag_2c">
}
        @if (countryCorporation === 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_FOREIGN_AGENT_ADDR_2']" [disabled]="batch_flag_2c">
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>City:</div>
      <div class="col-md-6">
        @if (countryCorporation !== 'US') {
<input class="form-control" type="text" maxlength="50" [(ngModel)]="attribData['5471_NA_FOREIGN_AGENT_F_CITY']"
               (ngModelChange)="change2c('5471_NA_FOREIGN_AGENT_F_CITY', attribData['5471_NA_FOREIGN_AGENT_F_CITY'])" [disabled]="batch_flag_2c">
}
        @if (countryCorporation === 'US') {
<input class="form-control" type="text" maxlength="50" [(ngModel)]="attribData['5471_NA_FOREIGN_AGENT_CITY']"
               (ngModelChange)="change2c('5471_NA_FOREIGN_AGENT_CITY', attribData['5471_NA_FOREIGN_AGENT_CITY'])" [disabled]="batch_flag_2c">
}
        @if (city_flag_2c) {
<span class="form-error-container">City is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>State:</div>
      <div class="col-md-6">
        @if (countryCorporation === 'US') {
<select class="form-control" [(ngModel)]="attribData['5471_NA_FOREIGN_AGENT_STATE']"
                (ngModelChange)="change2c('5471_NA_FOREIGN_AGENT_STATE', attribData['5471_NA_FOREIGN_AGENT_STATE'])" [disabled]="batch_flag_2c">
          <option value="">Select State</option>
          @for (state of states; track $index) {
<option [value]="state.CODE">{{ state.CODE }} - {{ state.NAME }}</option>
}
        </select>
}
        @if (countryCorporation !== 'US') {
<input type="text" maxlength="17" class="form-control" [(ngModel)]="attribData['5471_NA_FOREIGN_AGENT_F_STATE']"
               (ngModelChange)="change2c('5471_NA_FOREIGN_AGENT_F_STATE', attribData['5471_NA_FOREIGN_AGENT_F_STATE'])" [disabled]="batch_flag_2c">
}
        @if (state_flag_2c) {
<span class="form-error-container">State is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Zip/Postal Code:</div>
      <div class="col-md-6">
        @if (countryCorporation !== 'US') {
<input class="form-control" type="text" maxlength="16" [(ngModel)]="attribData['5471_NA_FOREIGN_AGENT_F_ZIP']"
               (ngModelChange)="change2c('5471_NA_FOREIGN_AGENT_F_ZIP', attribData['5471_NA_FOREIGN_AGENT_F_ZIP'])" [disabled]="batch_flag_2c">
}
        @if (countryCorporation === 'US') {
<input class="form-control" type="text" maxlength="5" [(ngModel)]="attribData['5471_NA_FOREIGN_AGENT_ZIP']"
               (ngModelChange)="change2c('5471_NA_FOREIGN_AGENT_ZIP', attribData['5471_NA_FOREIGN_AGENT_ZIP'])" [disabled]="batch_flag_2c">
}
        @if (zip_flag_2c) {
<span class="form-error-container">Zip is required</span>
}
        @if (zip_flag_2c_pattern) {
<span class="form-error-container">Please enter valid Zip Code</span>
}
      </div>
    </div>

    <!-- Section 2d - Person with custody -->
    <div class="row form-group">
      <div class="col-md-6">
        <b>&emsp;&emsp;d.&emsp;</b>Name and address (including corporate department, if applicable) of person (or person's) with custody
        of the books and records of foreign corporation and the location of such books and records, if different.
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <label>
              <input type="radio" name="2dType" value="P" [(ngModel)]="attribData['5471_NA_2D_FLAG']" (ngModelChange)="personBnssChange()" [disabled]="batch_flag_2d"/> Person
            </label>
          </div>
          <div class="col-md-4">
            <label>
              <input type="radio" name="2dType" value="B" [(ngModel)]="attribData['5471_NA_2D_FLAG']" (ngModelChange)="personBnssChange()" [disabled]="batch_flag_2d"/> Business
            </label>
          </div>
          <div class="col-md-4">
            <label>
              <input type="radio" name="2dType" value="N" [(ngModel)]="attribData['5471_NA_2D_FLAG']" (ngModelChange)="personBnssChange()" [disabled]="batch_flag_2d"/> Not Applicable
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Name Line 1:</div>
      <div class="col-md-6">
        <input class="form-control" type="text" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_NAME_1']"
               [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d"
               (ngModelChange)="change2d('5471_NA_PER_RECORDS_CUST_NAME_1', attribData['5471_NA_PER_RECORDS_CUST_NAME_1'])">
        @if (line_2d_name) {
<span class="form-error-container">Name of person with custody of the books and records is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Name Line 2 (allowed only if name/address type is Business):</div>
      <div class="col-md-6">
        <input class="form-control" type="text" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_NAME_2']"
               [disabled]="attribData['5471_NA_2D_FLAG'] !== 'B' || batch_flag_2d">
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Country:</div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="countryCust" (ngModelChange)="changeCountryCust(countryCust)"
                [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d">
          <option value="">Select Country</option>
          @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE">
            {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
          </option>
}
        </select>
        @if (line_2d_country_flag) {
<span class="form-error-container">Country is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Address Line 1:</div>
      <div class="col-md-6">
        @if (countryCust !== 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_F_ADDR_1']"
               [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d"
               (ngModelChange)="change2d('5471_NA_PER_RECORDS_CUST_F_ADDR_1', attribData['5471_NA_PER_RECORDS_CUST_F_ADDR_1'])">
}
        @if (countryCust === 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_US_ADDR_1']"
               [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d"
               (ngModelChange)="change2d('5471_NA_PER_RECORDS_CUST_US_ADDR_1', attribData['5471_NA_PER_RECORDS_CUST_US_ADDR_1'])">
}
        @if (add_flag_2d || add_flag_2d_f) {
<span class="form-error-container">Adrress Line 1 is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Address Line 2:</div>
      <div class="col-md-6">
        @if (countryCust !== 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_F_ADDR_2']"
               [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d">
}
        @if (countryCust === 'US') {
<input class="form-control" type="text" maxlength="35" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_US_ADDR_2']"
               [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d">
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>City:</div>
      <div class="col-md-6">
        @if (countryCust !== 'US') {
<input class="form-control" type="text" maxlength="50" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_F_CITY']"
               [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d"
               (ngModelChange)="change2d('5471_NA_PER_RECORDS_CUST_F_CITY', attribData['5471_NA_PER_RECORDS_CUST_F_CITY'])">
}
        @if (countryCust === 'US') {
<input class="form-control" type="text" maxlength="50" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_US_CITY']"
               [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d"
               (ngModelChange)="change2d('5471_NA_PER_RECORDS_CUST_US_CITY', attribData['5471_NA_PER_RECORDS_CUST_US_CITY'])">
}
        @if (city_flag_2d) {
<span class="form-error-container">City is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>State:</div>
      <div class="col-md-6">
        @if (countryCust === 'US') {
<select class="form-control" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_US_STATE']"
                [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d"
                (ngModelChange)="change2d('5471_NA_PER_RECORDS_CUST_US_STATE', attribData['5471_NA_PER_RECORDS_CUST_US_STATE'])">
          <option value="">Select State</option>
          @for (state of states; track $index) {
<option [value]="state.CODE">{{ state.CODE }} - {{ state.NAME }}</option>
}
        </select>
}
        @if (countryCust !== 'US') {
<input type="text" maxlength="17" class="form-control" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_F_STATE']"
               [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d"
               (ngModelChange)="change2d('5471_NA_PER_RECORDS_CUST_F_STATE', attribData['5471_NA_PER_RECORDS_CUST_F_STATE'])">
}
        @if (state_flag_2d) {
<span class="form-error-container">State is required</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Zip/Postal Code:</div>
      <div class="col-md-6">
        @if (countryCust !== 'US') {
<input class="form-control" type="text" maxlength="16" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_F_ZIP']"
               [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d"
               (ngModelChange)="change2d('5471_NA_PER_RECORDS_CUST_F_ZIP', attribData['5471_NA_PER_RECORDS_CUST_F_ZIP'])">
}
        @if (countryCust === 'US') {
<input class="form-control" type="text" maxlength="5" [(ngModel)]="attribData['5471_NA_PER_RECORDS_CUST_US_ZIP']"
               [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d"
               (ngModelChange)="change2d('5471_NA_PER_RECORDS_CUST_US_ZIP', attribData['5471_NA_PER_RECORDS_CUST_US_ZIP'])">
}
        @if (zip_flag_2d) {
<span class="form-error-container">Zip is required</span>
}
        @if (zip_flag_2d_pattern) {
<span class="form-error-container">Please enter valid Zip Code</span>
}
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Identifying number (if any)</div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <input class="form-control" type="text" maxlength="10" [(ngModel)]="attribData['5471_NA_2D_EIN_NUMBER']"
                   (ngModelChange)="unchecked()" [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d">
          </div>
          <div class="col-md-4">
            <input type="radio" name="identifyInfo" value="APPLD FOR" [(ngModel)]="attribData['5471_NA_2D_EIN_MISSING_REASON']" (click)="clicked()" [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d"/> Applied For
          </div>
          <div class="col-md-4">
            <input type="radio" name="identifyInfo" value="FOREIGNUS" [(ngModel)]="attribData['5471_NA_2D_EIN_MISSING_REASON']" (click)="clicked()" [disabled]="attribData['5471_NA_2D_FLAG'] === 'N' || batch_flag_2d"/> Not Applicable
          </div>
        </div>
      </div>
    </div>

  </div>
}
</div>

<!-- Modal Footer -->
@if (modal_name) {
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm save-button" type="button" (click)="saveForm()" [disabled]="crudLoading">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save and Proceed
  </button>
  <button class="btn btn-warning btn-sm cancel-button" type="button" (click)="cancel()">
    Cancel
  </button>
</div>
}
